import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { s_right_arrow, r_magic } from '@fiverr-private/icons';

const iconMapper = {
    'styled-list-item': {
        iconSvg: s_right_arrow,
        color: '#7a7d85',
        size: 12,
    },
    'spotlight-item': {
        iconSvg: r_magic,
        color: '#4a73e8',
        size: 14,
    },
};

const ItemIcon = ({ style }) => {
    const icon = iconMapper[style];

    if (!icon) {
        return null;
    }
    const { color, size, iconSvg } = icon;

    return (
        <Icon className="categories-icon" color={color} size={size}>
            {iconSvg}
        </Icon>
    );
};

ItemIcon.propTypes = {
    style: PropTypes.string,
};

export default ItemIcon;
